import React, { memo } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classnames from 'classnames/bind';
import { Portal } from '@wildberries/ui-kit';
import { TIME_TO_ENTER_MODAL, TIME_TO_EXIT_MODAL, TIME_TO_HOLD_MODAL, } from '../../../../constants';
import { NotificationsModal } from './_components/notification-modal';
import styles from './index.scss';
var BLOCK_NAME = 'Notifications-modals-container';
var cn = classnames.bind(styles);
export var NotificationsView = memo(function (_a) {
    var modalStack = _a.modalStack, closeModal = _a.closeModal, makeExternalAction = _a.makeExternalAction, _b = _a.zIndex, zIndex = _b === void 0 ? 100 : _b;
    return (React.createElement(Portal, { prefix: "notifications", zIndex: zIndex },
        React.createElement(TransitionGroup, { className: cn(BLOCK_NAME) }, modalStack.map(function (modalParams) {
            return (React.createElement(CSSTransition, { key: modalParams.id, timeout: {
                    enter: TIME_TO_ENTER_MODAL,
                    exit: TIME_TO_EXIT_MODAL,
                }, classNames: {
                    enter: cn("".concat(BLOCK_NAME, "__modal-animation-box--enter")),
                } },
                React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__modal-animation-box")) },
                    React.createElement(NotificationsModal, { status: modalParams.status, text: modalParams.text, key: modalParams.id, title: modalParams.title, id: modalParams.id, closeModal: closeModal, timeToHold: modalParams.customHoldTimeout || TIME_TO_HOLD_MODAL, externalAction: makeExternalAction, additionalActionType: modalParams.additionalActionType, additionalPayload: modalParams.additionalPayload, externalContent: modalParams.externalContent, disabledClose: modalParams.disabledClose, isClosing: modalParams.isClosing }))));
        }))));
});
